import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IUserProfilePayload {
    sagaCB?: {
        onSuccess: any
    }
}

export interface IUserProfie {
    status: string
    data: any
    errors: any
}

const initialState: IUserProfie = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const userProfieSlice = createSlice({
    name: 'hub/user/profile',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IUserProfilePayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const userProfieActions = userProfieSlice.actions
export default userProfieSlice.reducer
